import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndrawContent = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 898 607",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M888.329 0h-607a8.727 8.727 0 00-8.72 8.72v219.41h146.9a15.018 15.018 0 0115 15v185.63h453.82a8.712 8.712 0 006.63-3.06 2.044 2.044 0 00.19-.24 8.166 8.166 0 001.25-2.11 8.507 8.507 0 00.66-3.31V8.72a8.73 8.73 0 00-8.73-8.72z",
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ccc",
			d: "M273.85 34.951h621.957v2.493H273.85z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 295.039,
			cy: 18.698,
			r: 7.478,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 316.539,
			cy: 18.698,
			r: 7.478,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 338.04,
			cy: 18.698,
			r: 7.478,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M740.829 89.38h-312a13 13 0 000 26h312a13 13 0 000-26zm0 24h-312a11 11 0 010-22h312a11 11 0 010 22z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M836.3 192.95h-312a13 13 0 000 26h312a13 13 0 000-26zM836.3 240.95h-312a13 13 0 000 26h312a13 13 0 000-26zM836.3 288.95h-312a13 13 0 000 26h312a13 13 0 000-26z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M473.88 171.45H331.86a11.504 11.504 0 00-11.491 11.49v45.19h2v-45.19a9.505 9.505 0 019.49-9.49h142.02a9.498 9.498 0 019.49 9.49v142.02a9.498 9.498 0 01-9.49 9.49h-39.37v2h39.37a11.497 11.497 0 0011.49-11.49V182.94a11.497 11.497 0 00-11.49-11.49z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.624 317.568c-.503.02-21.91-1.464-22.457-1.483l1.923-19.197 12.193-.367 23.3-43.156c-3.231-6.162.745-14.338 7.6-15.598 13.814-3.14 18.56 18.593 4.704 21.485l-19.273 52.734a8.55 8.55 0 01-7.99 5.582z",
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.184 327.455c-20.371.05-22.16-30.737-1.743-32.907 53.989-3.262 47.157-16.822 51.256 23.175a4.505 4.505 0 01-3.994 4.954l-43.75 4.684a16.635 16.635 0 01-1.769.094z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.535 230.115c28.064 15.97 5.025 58.106-23.563 43.102-28.063-15.97-5.024-58.106 23.563-43.102zM70.049 592.823l12.259-.001 5.833-47.288-18.094.001.002 47.288z",
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.422 604.207l38.53-.002c-.146-19.88-25.917-14.152-38.53-14.885z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffb8b8",
			d: "M17.049 592.823l12.259-.001 5.833-47.288-18.094.001.002 47.288z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.422 604.207l38.53-.002c-.146-19.88-25.917-14.152-38.53-14.885zM30.982 576.308c-2.963-.813-19.064 1.646-20.964-1.582-6.636-66.511-5.161-131.603 9.57-167.37l50.648-3.1c11.326 20.675 37.36 157.874 21.656 166.216l-20.195.72a5.018 5.018 0 01-5.039-3.827l-16.895-96.117c-4.207-5.88-12.477 101.225-13.843 100.824a4.978 4.978 0 01-4.938 4.236z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.979 415.763c-25.572-26.754-9.26-98.479-10.086-96.953.07-1.757 5.862-28.816 20.845-33.257 11.886-3.923 25.043 7.812 26.666 19.68L73.21 410.387a3.698 3.698 0 01-1.014 3.18c.876 2.726-52.965 1.65-54.217 2.196z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.278 248.933c2.246-1.42 3.353-3.854 4.66-6.072 6.885-3.924 14.8 5.569 22.083 2.026 20.593-19.77-.574-25.602-19.54-26.644-4.48-.552-8.292 1.037-11.68 3.662-37.885-2.894-19.716 47.483 4.195 54.136 4.221 1.85 7.388-1.893 3.665-5.295-5.15-5.4-11.531-16.27-3.383-21.813z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M419.51 226.13h-274a17.024 17.024 0 00-17 17v346a17.024 17.024 0 0017 17h274a17.024 17.024 0 0017-17v-346a17.024 17.024 0 00-17-17zm15 363a15.018 15.018 0 01-15 15h-274a15.018 15.018 0 01-15-15v-346a15.018 15.018 0 0115-15h274a15.018 15.018 0 0115 15z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.307 371.728c-9.03 1.023-12.996-19.992-16.448-25.347l17.985-6.983 5.852 10.703 49.028 1.219a10.678 10.678 0 01.952-1.12c9.723-10.181 25.557 5.073 15.871 15.232a11.036 11.036 0 01-16.496-.478c-1.211.087-55.56 6.806-56.744 6.774z",
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.988 361.696c-3.007 2.898-26.09-37.773-27.777-38.922-11.665-18.13 15.795-36.03 27.66-17.998l23.998 36.879a4.505 4.505 0 01-1.318 6.225c-1.093.512-21.791 14.918-22.563 13.816z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M365.51 465.63h-166c-16.957-.082-17.028-25.911 0-26h166c16.945.08 17.036 25.911 0 26zM365.51 513.63h-166c-16.957-.082-17.028-25.911 0-26h166c16.945.08 17.036 25.911 0 26zM365.51 561.63h-166c-16.957-.082-17.028-25.911 0-26h166c16.945.08 17.036 25.911 0 26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.51 258.13a26 26 0 1126-26 26.03 26.03 0 01-26 26z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M439.51 231.13h-11v-12.5a1 1 0 00-2 0v12.5h-11a1 1 0 000 2h11v12.5a1 1 0 102 0v-12.5h11a1 1 0 000-2z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M362.51 408.43h-160a16.519 16.519 0 01-16.5-16.5v-89.6a16.519 16.519 0 0116.5-16.5h160a16.519 16.519 0 0116.5 16.5v89.6a16.519 16.519 0 01-16.5 16.5z",
			fill: "#6c63ff"
		})
	]
});
export default SvgUndrawContent;
